import {
  CButton,
  CCardHeader,
  CCol,
  CForm,
  CInput,
  CLabel,
  CRow,
  CSpinner,
  CInvalidFeedback,
  CFormGroup,
  CInputCheckbox,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { apiCallSPGet, apiCallSPPost } from "src/_apiConfig/apiCall";
import { useHistory } from "react-router-dom";
import Auth from "src/auth";
import {
  addToastError,
  addToastSuccess,
  AlertResponse,
} from "src/_constants/alert.type";
import ToastMessage from "src/_components/ToastMessage";

// import usersData from "../users/UsersData";
const RoleAdd = () => {
  // const { addToast } = useToast();

  const history = useHistory();
  const [loading, setloading] = useState(false);
  const [roleName, setRoleName] = useState("");
  const [isActive, setIsActive] = useState(false);
  const { authenticated } = Auth();

  const [submitted, setSubmitted] = useState(false);
  const [toasts, setToasts] = useState(AlertResponse);
  useEffect(() => {
    getRightsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  const [validated, setValidated] = useState(false);
  const [menuListData, setMenuListData] = useState([]);
  const [menuData, setMenuData] = useState([]);
  const [isRightCheck, setIsRightCheck] = useState(false);
  useEffect(() => {});
  // const DisplayToastMessage = (message, type) => {
  //   SetShowHideAlert((prevState) => ({
  //     ...prevState,
  //     ShowHide: true,
  //     AlertMessage: message,
  //     AlertType: type,
  //   }));
  // };

  const getRightsList = async () => {
    if (authenticated) {
      setloading(true);
      await apiCallSPGet(`RoleRights/ListById?roleid=0`).then((res) => {
        if (res.success) {
          setMenuListData(res.data);
          setMenuData(res.data);
        }
        setloading(false);
      });
    }
  };

  const handleRoleDetails = (e, index) => {
    console.log("handleRoleDetails e : ", e);
    console.log("handleRoleDetails index : ", index);
    console.log("handleRoleDetails menuData : ", menuData);

    index = index - 1;
    menuData[index].isMapped = e.target.checked;
    setMenuData([...menuData]);

    (menuData[index].parentId === 0 || menuData[index].parentId > 0) &&
      menuData
        .filter(
          (x) => menuData[index].rightsId === x.parentId && x.parentId > 0
        )
        // eslint-disable-next-line array-callback-return
        .map((res) => {
          menuData[res.srNo - 1].isMapped = e.target.checked;
          setMenuData([...menuData]);

          // handleRoleDetailsAction(e.target.checked, res.ModuleId);
        });

    const rightCheckList = [];
    // eslint-disable-next-line array-callback-return
    menuData.map((data) => {
      if (data.isMapped === true) {
        rightCheckList.push(data.rightsId);
      }
    });

    setIsRightCheck(rightCheckList.length === 0);
  };

  const CheckBox = (res, index, checkBoxPreFix) => {
    //let checkBoxPreFix = isSubMenu === true ? "subMenu" : "menu";
    return (
      <>
        <CFormGroup variant="custom-checkbox" inline>
          <CInputCheckbox
            custom
            id={`${checkBoxPreFix}${index}`}
            name={`${checkBoxPreFix}${index}`}
            value={res.rightsId}
            onChange={(e) => handleRoleDetails(e, res.srNo)}
            checked={res.isMapped === true ? "checked" : ""}
            disabled={
              res.parentId === 0
                ? false
                : !menuListData.find(
                    (item) => item.rightsId === res.parentId && item.isMapped
                  )
            }
          />
          <CLabel
            variant="custom-checkbox"
            htmlFor={`${checkBoxPreFix}${index}`}
          >
            {res.title}
          </CLabel>
        </CFormGroup>
        {/* <div className="checkbox-wrapper">
          <label>
            <input
              key={index}
              type="checkbox"
              value={res.rightsId}
              onChange={(e) => handleRoleDetails(e, res.srNo)}
              checked={res.isMapped === true ? "checked" : ""}
              disabled={
                res.parentId === 0
                  ? false
                  : !menuListData.find(
                      (item) => item.rightsId === res.parentId && item.isMapped
                    )
              }
            />
            <span>{res.title}</span>
          </label>
        </div> */}
      </>
    );
  };
  const SubMenuDataTable = (moduleId, columnClassName = "") => {
    //console.log(moduleId)
    const getSubMenuListItem = menuListData.filter(
      (res) => res.parentId === moduleId
    );

    return (
      <div className="row tableWith99Start">
        {getSubMenuListItem.length > 0 ? (
          getSubMenuListItem.map((res, index) => {
            return (
              <div className="col-xl-4 col-md-6" key={index}>
                {CheckBox(res, index, "subMenu")}
              </div>
            );
          })
        ) : (
          <div className="col-xl-4 col-md-6"> </div>
        )}
      </div>
    );
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    //setSubmitted(true);
    setloading(true);
    const form = event.currentTarget;
    const rightCheckList = [];
    // eslint-disable-next-line array-callback-return
    menuData.map((data) => {
      if (data.isMapped === true) {
        rightCheckList.push(data.rightsId);
      }
    });

    if (form.checkValidity() === false || rightCheckList.length === 0) {
      setSubmitted(true);
      if (rightCheckList.length === 0) {
        setIsRightCheck(true);
      }

      //event.stopPropagation();
    } else {
      // if (rightCheckList.length === 0) {
      //   addToastError(
      //     setToasts,
      //     "You have to Select atleast one Field in Menu "
      //   );
      // } else {
      const data = JSON.stringify({
        roleName: roleName,
        isActive: !!isActive,
        parentid: 0,
        insertby: authenticated.userId,
        subroleid: 1, //1 means - subrole = 1 = CGMF
      });
      await apiCallSPPost("RoleMaster/Insert", data).then(async (res) => {
        if (res.success) {
          console.log("handleSubmit : ", res);
          //alert("data added Succefully");
          await handleSubmitRigth(event, res.data, rightCheckList);
          //  history.push("/master/role");
        } else {
          addToastError(setToasts, res.message, 0);
        }

        setloading(false);
      });
    }
    setValidated(true);
    setloading(false);
  };

  const handleSubmitRigth = async (event, roleId, rightCheckList) => {
    event.preventDefault();

    setloading(true);

    if (rightCheckList.length > 0 && roleId > 0) {
      const submitdata = JSON.stringify({
        roleid: roleId,
        rightsid: rightCheckList.join(","),
        insertby: authenticated.userId,
      });

      await apiCallSPPost("RoleRights/MappingInsert", submitdata).then(
        (res) => {
          if (res.success) {
            addToastSuccess(setToasts, res.message);
            //alert("data added Succefully");
            history.push("/master/role");
          }

          setloading(false);
        }
      );
    } else {
      setloading(false);
    }
  };
  return (
    <>
      <ToastMessage toasts={toasts} setToasts={setToasts} />
      <CCardHeader>
        <CRow xl={12} className="pt-3 ">
          <CCol xl={10}>
            <h3>Add Role Right</h3>
          </CCol>
        </CRow>
      </CCardHeader>

      <CForm
        onSubmit={handleSubmit}
        noValidate
        validated={validated}
        className="was-validation"
      >
        <CRow className="mb-3 ml-1 mt-2">
          <CCol xl={4}>
            <CLabel> Role Name : </CLabel>
            <CInput
              required
              type="text"
              value={roleName}
              onChange={(e) => setRoleName(e.target.value)}
              id="validationCustom03"
              invalid={submitted && roleName === ""}
              aria-describedby="validationCustom03Feedback"
            />
            <CInvalidFeedback className="validationCustom03">
              Please enter Role Name
            </CInvalidFeedback>
          </CCol>
          {/* className="role-content" */}
          <CCol xl={2}>
            <CLabel htmlFor="formFile" className="col-form-label">
              IsActive:
            </CLabel>

            <input
              style={{
                margin: 10,
              }}
              id="chkIsViewOnly"
              placeholder=""
              type="checkbox"
              checked={isActive ? true : false}
              onClick={() => {
                setIsActive(!isActive);
              }}
            />
          </CCol>
          <CCol xl={2}></CCol>
        </CRow>
        {isRightCheck === true && (
          <CRow className="mb-3 ml-1 mt-2">
            <CCol
              xl={12}
              style={{
                width: "100%",
                marginTop: "0.25rem",
                fontSize: "80%",
                color: "#e55353",
              }}
            >
              You have to Select atleast one Field in Menu{" "}
            </CCol>
          </CRow>
        )}
        <CRow className={"ml-1"}>
          <CCol>
            <table className="table table-striped table-hover ml-1">
              <thead>
                <tr>
                  {/* <th>Sr. No</th> */}
                  <th style={{ width: "20%" }}>Menu</th>
                  <th>Sub Menu</th>
                  {/* <th style={{ width: "5%" }}>Sr. No</th>
                      <th style={{ width: "20%" }}>Menu</th>
                      <th style={{ width: "19%" }}>Sub Menu</th> 
                       <th className="">Action</th> */}
                </tr>
              </thead>
              <tbody>
                {menuListData.length > 0 &&
                  menuListData.map((res, index) => {
                    if (res.parentId === 0) {
                      return (
                        <tr>
                          <td>{CheckBox(res, index, "menu")}</td>
                          <td colSpan={2}>{SubMenuDataTable(res.rightsId)}</td>
                        </tr>
                      );
                    } else {
                      return null;
                    }
                  })}
              </tbody>
            </table>

            <CInvalidFeedback className="validationCustom04">
              You have to Select atleast one Menu
            </CInvalidFeedback>
          </CCol>
        </CRow>
        <CRow className="mb-2 ml-4 mt-2">
          {loading ? (
            <CSpinner className="spinner-grow" color="success" variant="grow" />
          ) : (
            <>
              <CButton type="submit" color="success">
                Add
              </CButton>

              <CButton color="danger" className="ml-2" to="/master/role">
                Cancel
              </CButton>
            </>
          )}
        </CRow>
      </CForm>
    </>
  );
};
export default RoleAdd;
